import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'siu-alert-box',
  templateUrl: './alert-box.component.html',
  styleUrls: [ './alert-box.component.scss' ]
})
export class AlertBoxComponent implements OnInit {

  @Input() text: string;
  @Input() type: 'success' | 'error' | 'warning' | 'info' = 'success';

  class: any;
  icon: string;

  constructor() { }

  ngOnInit() {
    this.class = { [ this.type ]: true }
    this.icon = this.buildIcon();
  }

  private buildIcon = () => {

    switch (this.type) {
      case 'success': return "check_circle_outline";
      case 'error': return "cancel";
      case 'warning': return "error_outline";
      case 'info': return "info";
      default: return '';
    }

  }

}
